import { connect } from 'react-redux'

var CurrentUser = require("lib/account/CurrentUser");
var ImageIcon = require("components/utility/icons/ImageIcon");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Skillsets = require("lib/academic/Skillsets");
var TextTypes = require("lib/academic/TextTypes");
var ReactTooltip = require("react-tooltip");
var WritingSelectors = require("lib/selectors/WritingSelectors");

require("writing/activities/activity_tile.scss")

@connect(
	(state, props) => ({
		isAdmin: CurrentUser.isAdmin(),
		tasks: WritingSelectors.tasks({ state }),
	})
)
class ActivityTile extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onAssignToggle(e) {
		$wr.nope(e)
		this.props.onItemAssign(this.props.item);
	}

	onOpenPrintable(e) {
		$wr.nope(e)
		var activity = this.props.item;

		Mycroft.newEvent({ category: "Printables", action: "view-activitiy", label: activity.key });
		setTimeout(function() {
			Mycroft.newEvent({ category: "Printables", action: "view-skillset", label: activity.format_summary.skillset });
		}, 1100);
		setTimeout(function() {
			Mycroft.newEvent({ category: "Printables", action: "view-format", label: activity.format_summary.format_class });
		}, 2200);

		window.open(activity.thumbnail.printable_url, "_blank");
	}

	onActivityClick() {
		if (this.props.nonInteractive) {
			return;
		}
		if (this.props.onClick) {
			this.props.onClick(this.props.item);
			return;
		}

		// Maybe we don't need this stuff? It'd be good to move it out of the class
		var passphrase = this.props.passphrase;
		if (passphrase == undefined) {
			var path = "/responses/new?activity_id=" + this.props.item.id;
		} else {
			var path = "/responses/access?activity_id=" + this.props.item.id +
				"&passphrase=" + passphrase;
		}

		if (passphrase != undefined) {
			$wr.redirect(path);
			
		} else if (this.props.forStudents) {
			window.open(path);

		} else {
			if (this.props.previewParameters) {
				path += "&" + $.param(this.props.previewParameters);
			}
			window.open(path, "_blank");
		}
	}
	// checks task to see if activity is assigned as task or task item
	assingedAsTask(activity) {
		var standAloneTasks = _.where(this.props.tasks, { subject_type: 'exercise', subject_id: activity.id.toString() })
		var taskItems = _.flatten(_.collect(_.pluck(this.props.tasks, 'task_items')))
		var matchingTaskItems = _.where(taskItems, { subject_type: 'exercise', subject_id: activity.id, subject_assigned: true })
		
		return _.size(standAloneTasks) || _.size(matchingTaskItems) ? true : false
	}

	render() {
		var activity = this.props.item;

		var buttonClassName = "buttonsBar";

		var textVariety = TextTypes.Varieties.getName(activity.format_summary.text_variety);
		var textCompletion = TextTypes.CompletionTypes.getPluralName(activity.format_summary.text_completion);
		if (this.props.isAdmin) {
			if (!this.props.nonInteractive) {
				if (this.props.hideAssignAction) {
					var assignmentControl = null;
				} else {
					if (this.props.assigned || activity.assigned || this.assingedAsTask(activity)) {
						buttonClassName += " assignedTile";
						var assignmentControl = (
							<li onClick={ this.onAssignToggle } className="assignedMarker">
								<span className="buttonTitle">Assigned</span>
								<Glyphicon icon="star" className="menuIcon" />
							</li>
						);				
					} else {
						var assignmentControl = (
							<li onClick={ this.onAssignToggle } className="dynamic assignMarker">
								<span className="buttonTitle">Assign</span>
								<Glyphicon icon="plus" className="menuIcon" />
							</li>
						);
					}
					if (activity.new) {
						var newMarker = (
							<li className="newMarker">
								<span className="buttonTitle">New</span>
								<Glyphicon icon="flash" className="menuIcon" />
							</li>
						);
					} else if (activity.featured) {
						buttonClassName += " featuredTile";

						var featuredMarker = (
							<li className="featuredMarker">
								<span className="buttonTitle">Featured</span>
								<Glyphicon icon="star" className="menuIcon" />
							</li>
						);
					}
					var printControl = (
						<li onClick={ this.onOpenPrintable } className="dynamic printMarker">
							<span className="buttonTitle">Print</span>
							<Glyphicon icon="print" className="menuIcon" />
						</li>
					);
				}
			}
		}

		if (this.props.unassignedDraft) {
			var textContent = (
				<div className="activityInfo smallText">
					<strong>{ activity.format_summary.title } </strong>
				</div>
			);
		} else {

			if (!this.props.forStudents) {
				var teacherDescription = activity.format_summary.teacher_description;
			}

			var textContent = (
				<div className="activityInfo smallText">
					<p>
						<strong>{ activity.format_summary.title } </strong>
						{ teacherDescription }
					</p>
					<p>
						<em>{ textVariety } { textCompletion }</em>
					</p>
				</div>
			);
		}

		var className = "tile activityTile";
		if (this.props.unassignedDraft) {
			className += " smallTile";
		}

		if (this.props.completedMark) {
			var completedMark = (
				<span className="completedMark">
					<Glyphicon icon="check" /> Done!
				</span>
			);
		}
		if (this.props.draftedMark) {
			var draftMarker = (
				<li className="draftMarker">
					<span className="buttonTitle">Finish</span>
					<Glyphicon icon="star-empty" className="menuIcon" />
				</li>
			);
		}

		if (this.props.completedAt) {
			var completedAt = (
				<div className="completedAt">
					Completed { $wr.formatDateTime(this.props.completedAt) }
				</div>
			);
		}

		if (this.props.item.format_summary.format_class == "CollaborationFormat") {
			var collaborationMarker = (
				<div className="smallText" data-tip="You get to do this activity with 1-4 of your classmates!">
					<img src={ require("misc/collaboration-icon.png") } className="collaborationImg" />
					<ReactTooltip effect="solid" />
				</div>
			);
		}

		if (this.props.nonInteractive) {
			className += " nonInteractive";
		}

		var skillset = activity.format_summary.skillset;

		return (
			<div className={ className }>
				<div className="imgContainer withImageHover">
					{ collaborationMarker }
					<div className={ buttonClassName }>
						<ul>
							{ featuredMarker }
							{ newMarker }
							{ assignmentControl }
							{ draftMarker }
							{ printControl }
						</ul>
					</div>
					<img src={ activity.thumbnail.url } className="tileImg" onClick={ this.onActivityClick } />
				</div>
				{ textContent }
				<div className="skillsetTitle smallText">
					<img src={ Skillsets.getIcon(skillset) } className="skillsetImg" />
					<span className="itemName">
						{ Skillsets.getName(skillset) }
					</span>
				</div>
				{ completedMark }
				{ completedAt }
			</div>
		);
	}
};

ActivityTile.propTypes = StrictPropTypes({
	// The activity
	item: PropTypes.object.isRequired,

	// Function to assign an item
	onItemAssign: PropTypes.func,

	// Overrides default onClick behavior. We pass the activity on to this function
	onClick: PropTypes.func,

	// Two types of drafts
	draftedMark: PropTypes.bool,
	unassignedDraft: PropTypes.bool,

	// If this is an assigned title (for teacher view)
	assigned: PropTypes.bool,

	// If we want to hide clickable behavior 
	nonInteractive: PropTypes.bool,

	// If this is an assigned title (for teacher view)
	forStudents: PropTypes.bool,

	// Show a completed mark underneath the tile
	// A little hacky, perhaps
	completedMark: PropTypes.bool,
	// If provided, shows the date completed underneath the tile
	completedAt: PropTypes.string,

	// If provided, this user is using passphrase access
	// And we should link them to a different path
	passphrase: PropTypes.string,

	// Makes this a preview card (for teachers)
	previewParameters: PropTypes.object,

	hideAssignAction: PropTypes.bool,
});

module.exports = ActivityTile;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/ActivityTile.js